import { render } from "./Profile.vue?vue&type=template&id=60ff91df"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=60ff91df&lang=css"

import exportComponent from "D:\\Shivani\\myProjects\\p2p_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__